import { useCompanyMaintenanceTracked } from "presentation/store/Company/CompanyMaintenanceProvider";
import { memo } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import CompanyFormPanel from "./RightPanel/CompanyFormPanel";
import CompanyTablePanel from "./Table/CompanyTablePanel";

const CompanyContent: React.FC = () => {
        const [companyState] = useCompanyMaintenanceTracked();
        const { isShowRightPanel } = companyState;

        return <div className={`main-comp-wrapper${isShowRightPanel ? '' : ' im-hide-side-form-draggable'}`}>
                <SliderPanel
                        isOpen={isShowRightPanel}
                        leftSectionWidth={isShowRightPanel ? '70%' : '100%'}
                        rightSectionWidth={isShowRightPanel ? '30%' : '0%'}
                        draggable={true}
                        leftChildren={<CompanyTablePanel />}
                        rightChildren={<CompanyFormPanel />} />
        </div>
}

export default memo(CompanyContent);